module.exports = __webpack_public_path__ + "img/sendUsBackground.a85dc08f.svg";